import { render, staticRenderFns } from "./region.vue?vue&type=template&id=c3e2e89e&lang=pug"
import script from "./region.vue?vue&type=script&lang=js"
export * from "./region.vue?vue&type=script&lang=js"
import style0 from "./region.vue?vue&type=style&index=0&id=c3e2e89e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports